import { FilaTarefa } from './fila-tarefa';

export class FilaFuncionario {
  idFila: number;
  idFuncionario: number;
  nome: string;
  disponivelGestor: boolean;
  disponivel: boolean;
  qtdTarefaAtiva: number;
  perfil: string;
  tarefas: FilaTarefa[];
  buscandoTarefas: boolean;
  qtdeTarefas: number | null;
  dataAtribui: Date | null;

  tabExpandida: boolean;
}
